/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography2, breakpoints } from '@coursera/cds-core';

import DottedSeparator from 'bundles/unified-description-page-common/components/shared/DottedSeparator';
import Rating from 'bundles/unified-description-page-common/components/shared/Rating';
import { durationToHours } from 'bundles/unified-description-page-common/utils/learningTime';

import _t from 'i18n!nls/xdp';

export type CourseItemSubtitleElement = React.ReactElement<Props, typeof CourseItemSubtitle>;

type Props = {
  courseIndex: number;
  totalContentDuration?: string;
  rating?: number | null;
  ratingCount?: number | null;
};

const styles = {
  container: css`
    display: flex;
    margin-top: var(--cds-spacing-50);
    white-space: nowrap;

    ${breakpoints.down('sm')} {
      flex-wrap: wrap;
      white-space: unset;
    }
  `,
};

const CourseItemSubtitle = ({ courseIndex, totalContentDuration, rating, ratingCount }: Props) => {
  return (
    <Typography2 variant="bodySecondary" color="supportText" component="div" css={styles.container}>
      {/* eslint-disable-next-line */}
      <FormattedMessage message={_t('Course {courseIndex}')} courseIndex={courseIndex} />
      {totalContentDuration && (
        <React.Fragment>
          <DottedSeparator />
          <span>{durationToHours(totalContentDuration)}</span>
        </React.Fragment>
      )}
      {Boolean(rating) && (
        <React.Fragment>
          <DottedSeparator />
          <Rating rating={rating} ratingCount={ratingCount} />
        </React.Fragment>
      )}
    </Typography2>
  );
};

export default CourseItemSubtitle;
